import React, { useContext } from 'react';

import { type ILayoutConfig } from './LayoutConfigProvider';

const layoutDefault: ILayoutConfig = {
  layoutConfig: {
    parametersDefault: undefined,
  },
};

const LayoutConfigContext = React.createContext<ILayoutConfig>(layoutDefault);

const useLayoutConfigContext = () => useContext(LayoutConfigContext);

export { useLayoutConfigContext };

export default LayoutConfigContext;
